import React from 'react';
import { Tag } from 'antd';
import classnames from 'classnames';
import { deliveryTimeDifferenceMinutes } from '../../services/helpers/OrderMath';

export default function DeliveryTimeDifferenceBadge({ initial, actual, className }) {
  if (initial === actual) {
    return null;
  }

  const diff = deliveryTimeDifferenceMinutes(initial, actual);

  return (
    <Tag color={diff < 0 ? 'success' : 'red'} className={classnames('text-center', className)}>
      {diff < 0 ? '-' : '+'}
      {Math.abs(diff)}
      {' min'}
    </Tag>
  );
}
